import { Route, Routes } from 'react-router-dom';
import { TaxReturnsRoutes } from './routes/TaxReturns/routes';
import TaxAdvicePage from './routes/TaxAdvice';
import PaymentSuccess from './routes/TaxPayment/PaymentSuccess';
import PaymentCancel from './routes/TaxPayment/PaymentCancel';
import ContainerWrapper from '../layout/ContainerWrapper';
import TaxDealStage from './routes/TaxReturns/components/TaxDealStage';
import NotFoundPage from '../mics/routes/NotFound';
import TaxPage from './routes/TaxPage';
import HealthCheck from './routes/HealthCheck';

export const TaxRoutes = () => {
  return (
    <ContainerWrapper>
      <Routes>
        <Route path="/" element={<TaxPage />} />
        <Route path="tax-returns/*" element={<TaxReturnsRoutes />} />
        <Route path="tax-advice/" element={<TaxAdvicePage />} />
        <Route path="tax-deal-stage/" element={<TaxDealStage />} />
        <Route path="payment/success" element={<PaymentSuccess />} />
        <Route path="payment/cancel" element={<PaymentCancel />} />
        <Route path="health-check" element={<HealthCheck />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ContainerWrapper>
  );
};
